import useSWR from 'swr'
import { requestWithCache } from 'lib/api'
import { ENDPOINTS } from 'lib/api/const'

const useSearch = (fetchOptions, initialData) => {
  const { data, error, mutate, isValidating } = useSWR(
    [ENDPOINTS.productsSearch.link, fetchOptions],
    requestWithCache,
    {
      dedupingInterval: ENDPOINTS.productsSearch.cache,
      // Seems to be a bug from the lib(?), if initialData is set, changing sort/filter won't trigger refetch
      // By doing this hack the SSR will be rendered correctly, but client side still need to fetch again
      initialData: typeof window === 'undefined' ? initialData : null,
    },
  )

  return { data, error, retry: mutate, isValidating }
}

export default useSearch
